import { Col, Progress, Row } from 'antd';
import React, { useState, useEffect } from 'react'
import { withRouter } from "react-router-dom";
import { Collapse, Select } from 'antd';
import { CheckCircleTwoTone, SettingOutlined } from '@ant-design/icons';
import empty from '../../../../../../assets/empty.png'
import cross from '../../../../../../assets/cross.png'
import VehicleName from '../../../../../VehicleName'
import './index.less'
const { Panel } = Collapse;
const { Option } = Select;


const DetailsCard = ({ data }) => {
  return (
    <div style={{ backgroundColor: 'white' }}  >
      <Row className="box" align="middle" style={{ padding: '0.5rem 1rem', marginBottom: '0.25rem' }} >
        <Col xs={24} md={6}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0' }}>
            <img
              src={data.vehicle && data.vehicle.color?.url}
              style={{ width: '100%', maxWidth: '420px', height: '250px', objectFit: 'contain' }}
            />
          </div>
        </Col>
        <Col xs={24} md={16} style={{ padding: '0.75rem 1rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: '3rem' }}>
          <h2><VehicleName nameOnly value={data.vehicle?.vehicle} /></h2>
          <Row>
            <Col xs={24} md={12}>
              <table>
                <thead>
                  <tr>
                    <td style={{ fontWeight: 'bolder' }}>Customer Name</td>
                    <td>:</td>
                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data.customer && data.customer.name}</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 'bolder' }}>Register Number</td>
                    <td>:</td>
                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data.vehicle && data.vehicle.registerNo}</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 'bolder' }}>Service Advisor</td>
                    <td>:</td>
                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>
                      {
                        data && data.serviceAdvisor ?
                          data.serviceAdvisor.profile && data.serviceAdvisor.profile.employeeName
                          : "-"
                      }
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 'bolder' }}>Odometer Reading</td>
                    <td>:</td>
                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data && data.kms}</td>
                  </tr>
                </thead>
              </table>
            </Col>
            <Col xs={24} md={12}>
              <table>
                <thead>
                  <tr>
                    <td style={{ fontWeight: 'bolder' }}>Mechanic</td>
                    <td>:</td>
                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>
                      {
                        data && data.mechanic ?
                          data.mechanic.profile && data.mechanic.profile.employeeName
                          : "-"
                      }
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 'bolder' }}>Contact Number</td>
                    <td>:</td>
                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>96325 42999</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 'bolder' }}>Job Card</td>
                    <td>:</td>
                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data && data.jobNo}</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: 'bolder' }}>Branch</td>
                    <td>:</td>
                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>Devanahali</td>
                  </tr>

                </thead>
              </table>
            </Col>
          </Row>
        </Col>
      </Row>
      <Collapse
        expandIconPosition={'right'}
      >
        <Panel header="More Details" style={{ fontSize: '18px', fontWeight: 'bold' }} key="1" >
          <Row>
            <Col xs={24} md={8} style={{ borderRight: '0.1px solid rgba(0, 0, 0, 0.1)' }}>
              <h3>Pictures</h3>
              <div className="flexing">
                {data && data.vehicleImage && data.vehicleImage.frontView != null ?
                  <img
                    className="image"
                    src={data.vehicleImage && data.vehicleImage.frontView}
                    alt="Front View"
                  />
                  : <img
                    className="image"
                    src={empty}
                  />}
                {data && data.vehicleImage && data.vehicleImage.rearView != null ?
                  <img
                    className="image"
                    style={{ marginLeft: '1rem' }}
                    src={data.vehicleImage && data.vehicleImage.rearView}
                    alt="Front View"
                  />
                  : <img
                    style={{ marginLeft: '1rem' }}
                    className="image"
                    src={empty}
                  />}

              </div>

              <div className="flexing">
                {data && data.vehicleImage && data.vehicleImage.lhsView != null ?
                  <img
                    className="image"
                    src={data.vehicleImage && data.vehicleImage.lhsView}
                    alt="Front View"
                  />
                  : <img
                    className="image"
                    src={empty}
                  />}
                {data && data.vehicleImage && data.vehicleImage.rhsView != null ?
                  <img
                    className="image"
                    style={{ marginLeft: '1rem' }}
                    src={data.vehicleImage && data.vehicleImage.rhsView}
                    alt="Front View"
                  />
                  : <img
                    style={{ marginLeft: '1rem' }}
                    className="image"
                    src={empty}
                  />}
              </div>
              <div className="flexing">
                {data && data.vehicleImage && data.vehicleImage.topView != null ?
                  <img
                    className="image"
                    src={data.vehicleImage && data.vehicleImage.topView}
                    alt="Front View"
                  />
                  : <img
                    className="image"
                    src={empty}
                  />}
              </div>
            </Col>
            <Col style={{ display: 'flex', justifyContent: 'center', lineHeight: '25px', borderRight: '0.1px solid rgba(0, 0, 0, 0.1)', padding: '1rem', minHeight: '350px' }} xs={24} md={8}>
              <ul style={{ listStyleType: 'none', fontSize: '16px' }}>
                <li>{data.parts && data.parts.MirrorLH ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <img src={cross} style={{ height: '25px', width: '20px' }} />} Left Mirror</li>
                <li>{data.parts && data.parts.MirrorRH ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <img src={cross} style={{ height: '25px', width: '20px' }} />} Right Mirror</li>
                <li>{data.parts && data.parts.Toolkit ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <img src={cross} style={{ height: '25px', width: '20px' }} />} Tool Kit</li>
                <li>{data.parts && data.parts.FirstAdKit ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <img src={cross} style={{ height: '25px', width: '20px' }} />} First Aid Kit</li>
              </ul>
            </Col>
            <Col xs={24} md={8} style={{ padding: '1rem' }}>
              <h3>Fuel Level :</h3>
              {data && data.fuelLevel != null ? <Progress percent={data && (data.fuelLevel / 100) * 100} /> : <Progress percent={0} status="exception" />}
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </div >
  )
}
export default withRouter(DetailsCard); 